import { create }  from 'zustand';
import { Howl } from 'howler';

export const useStore = create((set) => ({
  init: () => {
    console.log('Store initialized');
  },

  // BETTINGFORM STATES
  count: 0,
  increment: () => set((state) => ({ count: state.count + 1 })),
  reset: () => set(() => ({ count: 0 })),
  betType: null,
  isBetPlaced: false,
  userPlaceBet: (type) => set((state) => ({
    betType: type,
    isBetPlaced: true
  }),
  ),
  resetAfterPlaced: () => set((state) => ({
    betType: null,
    isBetPlaced: false
  })),
  // GAMETIMER STATES
  timerStatus: null, // Enum: betting_open, draw, payout
  setTimerStatus: (newStatus) => set({ timerStatus: newStatus }),
  // RESULTS STATES
  resultsData:null, // Result socket
  setResultData: (newResults) => set({ resultsData: newResults }),
  // USERDATA STATES
  authUser:null,
  setAuthUser: (newAuth) => set({ authUser: newAuth }),
  // GAMEROUNDDATA STATES
  currentRound:null,
  setCurrentRound: (newRound) => set({ currentRound: newRound  }),
  // DYNAMIC RATE STATES
  currentUpBets: null,
  currentDownBets: null,
  totalUpBets: 0,
  totalDownBets: 0,
  currentUpWager: 0,
  currentDownWager: 0,
  setCurrentUpBets: (newUpBets) => set({ currentUpBets: newUpBets }),
  setCurrentDownBets: (newDownBets) => set({ currentDownBets: newDownBets }),
  setUpTotalBets: (newTotalUpBets) => set({ totalUpBets: newTotalUpBets}),
  setDownTotalBets: (newTotalDownBets) => set({ totalDownBets: newTotalDownBets}),
  setCurrentUpWager: (newCurrentUpWager) => set({ currentUpWager: newCurrentUpWager}),
  setCurrentDownWager: (newCurrentDownWager) => set({ currentDownWager: newCurrentDownWager}),
  // OPTIONSCHART (HIGHCHARTS)
  drawOpenPrice: 0,
  setDrawOpenPrice: (newDrawOpenPrice) => set({ drawOpenPrice: newDrawOpenPrice}),
  // SOUND SETTINGS
  initialized: false, // Add initialization flag
  // Initialize sound state on app startup
  initializeSound: () => set((state) => {
    if (!state.initialized) {
      // Set initial mute state
      Howler.mute(!state.isSoundOn);
      return { initialized: true };
    }
    return state;
  }),
  isSoundOn: false,
  toggleMute: () => set((state) => {
    const nextMuteState = !state.isSoundOn;
    // Apply the change globally to Howler
    Howler.mute(!nextMuteState); 
    return { isSoundOn: nextMuteState };
  }),
  // Draw History Modal State
 isDrawHistoryOpen: false,
  openDrawHistory: () => set({ isDrawHistoryOpen: true }),
  closeDrawHistory: () => set({ isDrawHistoryOpen: false }),
  // UsersBets Modal State
  isUsersBetsOpen: false,
  toggleUsersBetsPanel: () => set((state) => ({ isUsersBetsOpen: !state.isUsersBetsOpen })),
  // Draw History Data State
  drawHistoryData: null,
  setDrawHistoryData: (newDrawHistoryData) => set({ drawHistoryData: newDrawHistoryData }),
  // User Bets Details State
  userBetsDetails: null,
  setUserBetsDetails: (newUserBetsDetails) => set({ userBetsDetails: newUserBetsDetails }),
  // User Pending Bets State
  userPendingBets: [],
  setUserPendingBets: (newUserPendingBets) => set({ userPendingBets: newUserPendingBets }),
  // Betting Form: bet success state
  betSuccess: false,
  setBetSuccess: (isSuccess) => set({ betSuccess: isSuccess }),
  // Winning Bet Panel: user betting result
  userBettingResult: null,
  setUserBettingResult: (newUserBettingResult) => set({ userBettingResult: newUserBettingResult }),
  // User Betting History State
  userBettingHistory: [],
  setUserBettingHistory: (newUserBettingHistory) => set({ userBettingHistory: newUserBettingHistory }),
}));